import React, { PropsWithChildren } from "react";
import {
  ContentfulContext,
  ContentfulClientInterface,
} from "./ContentfulContext";

export interface ContentfulProviderProps {
  client: ContentfulClientInterface;
}

export const ContentfulProvider = ({
  client,
  children,
}: PropsWithChildren<ContentfulProviderProps>): React.JSX.Element => {
  return (
    <ContentfulContext.Provider value={client}>
      {children}
    </ContentfulContext.Provider>
  );
};
